var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6711 10.471H61.7131L56.2431 5H7.68311V86.597H15.6701L15.6711 10.471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7131 10.471L56.2431 5H7.68311V86.597H15.6701",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6719 15.9547H69.7139L64.2299 10.4707H15.6709V92.0677H23.6719V15.9547Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7139 15.9547L64.2299 10.4707H15.6709V92.0677H23.6719",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5879 49.3781V34.3121L72.2309 15.9551H23.6719V97.5521H46.2179",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6362 34.6357H68.7652",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6362 44.2646H68.7652",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6362 54.2881H68.7652",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5879 87.6833V66.9863",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29 97.5518H77.123",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.465 178.381L163.026 151.942C159.086 157.144 154.398 161.735 149.114 165.565L175.7 192.148C177.526 193.974 180.002 195 182.584 195C185.166 195 187.642 193.974 189.468 192.149C191.294 190.323 192.319 187.847 192.319 185.265C192.319 182.683 191.294 180.207 189.468 178.381H189.465Z",
    fill: "#EAEAEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.465 178.381L163.026 151.942C159.086 157.144 154.398 161.735 149.114 165.565L175.7 192.148C177.526 193.974 180.002 195 182.584 195C185.166 195 187.642 193.974 189.468 192.149C191.294 190.323 192.319 187.847 192.319 185.265C192.319 182.683 191.294 180.207 189.468 178.381H189.465Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.468 46.3252C101.816 46.3253 93.2479 48.0297 85.2541 51.341C77.2603 54.6522 69.997 59.5056 63.8788 65.6239C57.7607 71.7422 52.9076 79.0057 49.5965 86.9996C46.2855 94.9935 44.5814 103.561 44.5815 112.214C44.5817 120.866 46.286 129.434 49.5973 137.428C52.9086 145.421 57.7619 152.685 63.8803 158.803C69.9986 164.921 77.262 169.774 85.2559 173.085C93.2498 176.396 101.818 178.1 110.47 178.1C119.123 178.1 127.69 176.396 135.684 173.084C143.678 169.773 150.941 164.92 157.059 158.801C163.177 152.683 168.031 145.42 171.342 137.426C174.653 129.432 176.357 120.864 176.357 112.212C176.356 103.559 174.652 94.9915 171.341 86.9977C168.029 79.0039 163.176 71.7406 157.058 65.6225C150.94 59.5044 143.676 54.6512 135.682 51.3402C127.688 48.0292 119.121 46.3251 110.468 46.3252ZM110.468 161.603C99.0412 161.604 87.9676 157.642 79.1342 150.393C70.3007 143.145 64.254 133.057 62.0241 121.85C59.7943 110.643 61.5194 99.0094 66.9055 88.9316C72.2916 78.8537 81.0054 70.9552 91.5623 66.5818C102.119 62.2084 113.866 61.6307 124.801 64.9473C135.736 68.2638 145.182 75.2692 151.531 84.77C157.88 94.2708 160.739 105.679 159.619 117.051C158.5 128.423 153.472 139.055 145.392 147.135C136.129 156.397 123.567 161.6 110.468 161.6V161.603Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.468 82.0078C84.806 82.0078 64 112.213 64 112.213C64 112.213 84.8 142.418 110.466 142.418C136.132 142.418 156.933 112.218 156.933 112.218C156.933 112.218 136.131 82.0078 110.468 82.0078ZM110.468 139.581C106.421 139.581 102.425 138.684 98.7661 136.954C95.1076 135.224 91.8784 132.704 89.3111 129.576C86.7438 126.448 84.9023 122.789 83.9192 118.863C82.9361 114.938 82.836 110.843 83.626 106.874C84.6372 101.789 87.0719 97.0956 90.6467 93.3406C94.2215 89.5855 98.7894 86.9231 103.819 85.6632C108.848 84.4033 114.131 84.5978 119.054 86.2241C123.977 87.8503 128.337 90.8414 131.626 94.8491C134.915 98.8568 136.998 103.716 137.633 108.862C138.267 114.007 137.427 119.227 135.21 123.914C132.994 128.601 129.491 132.562 125.111 135.335C120.731 138.109 115.653 139.581 110.468 139.581Z",
    fill: "#EAEAEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.468 82.0078C84.806 82.0078 64 112.213 64 112.213C64 112.213 84.8 142.418 110.466 142.418C136.132 142.418 156.933 112.218 156.933 112.218C156.933 112.218 136.131 82.0078 110.468 82.0078Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.468 84.8452C106.86 84.8234 103.284 85.5152 99.944 86.8808C96.6045 88.2463 93.5679 90.2588 91.009 92.8022C88.4502 95.3457 86.4194 98.37 85.0337 101.701C83.648 105.032 82.9346 108.605 82.9346 112.213C82.9346 115.821 83.648 119.393 85.0337 122.724C86.4194 126.055 88.4502 129.08 91.009 131.623C93.5679 134.167 96.6045 136.179 99.944 137.545C103.284 138.91 106.86 139.602 110.468 139.58C117.698 139.537 124.616 136.634 129.713 131.506C134.81 126.379 137.671 119.443 137.671 112.213C137.671 104.983 134.81 98.0469 129.713 92.9192C124.616 87.7915 117.698 84.8889 110.468 84.8452Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.468 103.393C108.129 103.393 105.885 104.322 104.231 105.976C102.577 107.63 101.648 109.873 101.648 112.213C101.648 114.552 102.577 116.795 104.231 118.449C105.885 120.103 108.129 121.033 110.468 121.033C112.807 121.033 115.051 120.103 116.705 118.449C118.359 116.795 119.288 114.552 119.288 112.213C119.288 109.873 118.359 107.63 116.705 105.976C115.051 104.322 112.807 103.393 110.468 103.393Z",
    fill: "#EAEAEA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.468 103.393C108.129 103.393 105.885 104.322 104.231 105.976C102.577 107.63 101.648 109.873 101.648 112.213C101.648 114.552 102.577 116.795 104.231 118.449C105.885 120.103 108.129 121.033 110.468 121.033C112.807 121.033 115.051 120.103 116.705 118.449C118.359 116.795 119.288 114.552 119.288 112.213C119.288 109.873 118.359 107.63 116.705 105.976C115.051 104.322 112.807 103.393 110.468 103.393Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8779 143.803L142.194 80.4863",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M142.285 34.8799H153.62",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.952 40.5489V29.2139",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5581 183.336L33.5731 191.351",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5581 191.351L33.5731 183.336",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5303 121.503L35.6173 125.591",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5303 125.591L35.6173 121.503",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M184.542 160.085L188.047 165.865L192.168 157.23",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.356 15.9551H182.538",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.447 19.0473V12.8643",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.242749aa27d89734e7a5ecd951a4c1e3.svg";
export { ForwardRef as ReactComponent };